import {
  errorsList,
  errorsPresent,
  mergeServerValidationErrors,
} from "../../../../helpers/ErrorHelper";
import { endOfURL } from "../../../../helpers/UrlHelper";
import { isObject } from "../../../../helpers/DataHelper";
import { ServerMigrationState } from "./ServerMigration-State";

export default function serverMigrationReducer(
  state = ServerMigrationState,
  action
) {
  let { data } = { ...state };
  let { validationErrors, value, mode } = action;
  switch (action.type) {
    case "ON-SERVER-MIGRATION-CHANGE":
      data.payload["server_id"] = value;
      buildErrors();
      return { ...state, data };

    case "ON-SERVER-MIGRATION-MODE-CHANGE":
      data.mode = mode;
      buildErrors();
      return { ...state, data };

    case "SET-DEFAULT-SERVER-MIGRATION":
      data = {
        payload: {
          server_id: "",
          change_loadbalancer: 1,
        },
        errors: [],
        errorsPresent: false,
        submitted: false,
        dispatchAPI: false,
        mode: endOfURL(),
        message: ``,
      };
      buildErrors();
      return { ...state, data };

    case "CANCEL-SERVER-MIGRATION-DISPATCH":
      data.dispatchAPI = false;
      data.submitted = false;
      buildErrors();
      return { ...state, data };

    case "ON-SERVER-MIGRATION-SUBMIT":
      data.submitted = true;
      buildErrors();
      if (!data.errorsPresent) data.dispatchAPI = true;
      return { ...state, data };

    case "SERVER-MIGRATION-SERVER-VALIDATION-ERRORS":
      validationErrors &&
        isObject(validationErrors) &&
        Object.keys(validationErrors).map(
          (key) =>
            (data.errors[key] = [
              { message: ` - ${validationErrors[key][0]}`.slice(0, -1) },
            ])
        );
      data.dispatchAPI = false;
      return { ...state, data };

    default:
      return state;
  }

  function buildErrors() {
    data.errors = errorsList(errors);
    data.errorsPresent = errorsPresent(errors);
  }

  function errors(field) {
    let { payload, submitted, validationErrors } = data;
    let errors = {};
    Object.keys(payload).map((key) => (errors[key] = []));

    if (submitted) {
      if (field === `server_id`) {
        if (!_(field)) newError(field, 0, `is required`);
      }
    }

    errors = mergeServerValidationErrors(errors, validationErrors);

    return field ? errors[field] : errors;

    function newError(field, step, message) {
      errors && errors[field].push({ step, message });
    }

    function _(field) {
      return data.payload[field];
    }
  }
}
